import { getCurrentSection, handleStickyClick } from './stickyNavigation.js';
import trackEvent from '../util/trackEvent';

let navLinks = [];

function handleLinkClick(event) {
    handleStickyClick(event);
    trackEvent("Components", "Sidebar Navigation - clicked link");
}

function observerCallback(entries, observer) {
    const currentSection = getCurrentSection(entries, observer);

    if (currentSection) {
        document.querySelector(".sidebar-nav-link--selected") ? document.querySelector(".sidebar-nav-link--selected").classList.remove("sidebar-nav-link--selected") : null;
        document.querySelector(`.sidebar-nav-link[href="#${currentSection.id}"]`).classList.add("sidebar-nav-link--selected");
    }
}

// Init code
if (window && window.IntersectionObserver) {
    const observer = new IntersectionObserver(observerCallback, {rootMargin: '0% 0% -50% 0%'});
    navLinks = document.getElementsByClassName("sidebar-nav-link");

    for (let i = 0; i < navLinks.length; i++) {
        const destination = document.querySelector(navLinks[i].getAttribute("href"));
        if (destination) {
            observer.observe(destination);
            navLinks[i].addEventListener("click", handleLinkClick);
        }
        else
            destination.parentElement.removeChild(destination);
    }

    if (navLinks.length > 0)
        navLinks[0].classList.add("sidebar-nav-link--selected");
}
